import { Component, Input } from '@angular/core';

@Component({
  selector: 'zikatagov-textarea',
  template: `
    <textarea
      class="form-control"
      [id]="id"
      [rows]="rows"
      [placeholder]="placeholder"
      [disabled]="disabled"
    ></textarea>
  `,
   standalone: true
})
export class ZikataTextareaComponent {
  @Input() id = '';
  @Input() rows = 3;
  @Input() placeholder = '';
  @Input() disabled = false;
}
